import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Box,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { Warning } from '@mui/icons-material';

const CertificationAlertsCard = ({ certificationAlerts }) => {
  if (
    certificationAlerts.expired.length === 0 &&
    certificationAlerts.expiring30Days.length === 0 &&
    certificationAlerts.expiring60Days.length === 0
  ) {
    return null;
  }

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="error" />
        Certification Expiry Alerts
      </Typography>
      <Grid container spacing={2}>
        {certificationAlerts.expired.length > 0 && (
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 1, border: '1px solid', borderColor: 'error.main', borderRadius: 1, bgcolor: 'rgba(211, 47, 47, 0.1)' }}>
              <Typography variant="body2" color="error.main" fontWeight="bold">Expired</Typography>
              <Typography variant="h5" color="error.main">{certificationAlerts.expired.length}</Typography>
              <Typography variant="caption" color="textSecondary">certificates/trainings</Typography>
              <List dense sx={{ mt: 1, maxHeight: '200px', overflowY: 'auto' }}>
                {certificationAlerts.expired.slice(0, 10).map((item, idx) => (
                  <ListItem key={idx} dense>
                    <ListItemText
                      primary={item.itemName}
                      secondary={
                        <Box>
                          <Typography variant="caption" display="block">
                            {item.userName} • {item.itemType}
                          </Typography>
                          <Typography variant="caption" color="error">
                            Expired: {new Date(item.expiryDate).toLocaleDateString()}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        )}
        {certificationAlerts.expiring30Days.length > 0 && (
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 1, border: '1px solid', borderColor: 'error.main', borderRadius: 1, bgcolor: 'rgba(255, 152, 0, 0.1)' }}>
              <Typography variant="body2" color="error.main" fontWeight="bold">Expiring in 30 Days</Typography>
              <Typography variant="h5" color="error.main">{certificationAlerts.expiring30Days.length}</Typography>
              <Typography variant="caption" color="textSecondary">certificates/trainings</Typography>
              <List dense sx={{ mt: 1, maxHeight: '200px', overflowY: 'auto' }}>
                {certificationAlerts.expiring30Days.slice(0, 10).map((item, idx) => (
                  <ListItem key={idx} dense>
                    <ListItemText
                      primary={item.itemName}
                      secondary={
                        <Box>
                          <Typography variant="caption" display="block">
                            {item.userName} • {item.itemType}
                          </Typography>
                          <Typography variant="caption" color="warning.main">
                            Expires: {new Date(item.expiryDate).toLocaleDateString()}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        )}
        {certificationAlerts.expiring60Days.length > 0 && (
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 1, border: '1px solid', borderColor: 'warning.main', borderRadius: 1 }}>
              <Typography variant="body2" color="textSecondary" fontWeight="bold">Expiring in 60 Days</Typography>
              <Typography variant="h5" color="warning.main">{certificationAlerts.expiring60Days.length}</Typography>
              <Typography variant="caption" color="textSecondary">certificates/trainings</Typography>
              <List dense sx={{ mt: 1, maxHeight: '200px', overflowY: 'auto' }}>
                {certificationAlerts.expiring60Days.slice(0, 10).map((item, idx) => (
                  <ListItem key={idx} dense>
                    <ListItemText
                      primary={item.itemName}
                      secondary={
                        <Box>
                          <Typography variant="caption" display="block">
                            {item.userName} • {item.itemType}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            Expires: {new Date(item.expiryDate).toLocaleDateString()}
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default CertificationAlertsCard;

